import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Disable the React error overlay in development for benign promise rejections
// The overlay comes from react-error-overlay used by CRA
if (process.env.NODE_ENV === 'development') {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    // Filter out benign Radix UI promise rejections
    const message = args[0];
    if (typeof message === 'string') {
      if (message.includes('Unknown promise rejection') || 
          message.includes('unhandledrejection') ||
          message.includes('ResizeObserver')) {
        return; // Don't log these
      }
    }
    originalConsoleError.apply(console, args);
  };
}

// Suppress unhandled promise rejections from Radix UI / third-party libraries
// Must be set BEFORE any other code runs
window.addEventListener('unhandledrejection', (event) => {
  // Always prevent the default behavior (stops the error overlay)
  event.preventDefault();
  event.stopImmediatePropagation();
  
  // Only log meaningful errors for debugging
  if (event.reason && event.reason.message) {
    console.warn('[Suppressed]:', event.reason.message);
  }
}, true); // Use capture phase to catch it first

// Also suppress at error level
window.addEventListener('error', (event) => {
  if (event.message && (
    event.message.includes('ResizeObserver') || 
    event.message.includes('Script error') ||
    event.message.includes('Unknown')
  )) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />,
);
